module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo01-nikon_thumb-041e9d315d67cc454fc99d08de557608.jpg";